module.exports = "/fonts/vendor/pe7-icon/dist/Pe-icon-7-stroke.eot?1d449ea50ab8389ee0789989bf9e6ac0";